// App.js All routes is working currently
import React, { useEffect } from 'react';
import { Routes, Route } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { setLoginDetails } from './redux/slices/auth.Slice';
import { getUser } from './utility/AuthService';

// Auth-Service
import PrivateRoute from "./utility/PrivateRoute";

// Core Pages
import HomePage from "./views/pages/Home/Index";
import Progress from "./views/pages/Progress/Index";
import LoginPage from "./views/pages/auth/UserLogIn";
import RegisterPage from "./views/pages/auth/SignUp";
import ForgotPassword from "./views/pages/auth/ForgotPasswordpage";
import ResetPassword from "./views/pages/auth//ResetPassPage";
import OTPverify from "./views/pages/auth/OtpVerifyPage";
import NotFoundPage from "./views/pages/NotFound";
import Dashboard from "./views/pages/dashboard/dashboard";
import History from "./views/pages/history/History";
import PdfReportPage3 from "./views/pages/pdfReport/PdfReportPage3";
import ProfilePage from "./views/pages/ProfilePage";
import AssociatedCompaniesPage from "./views/pages/associatedCompanies/AssociatedCompaniesPage";
import AnalyticsPage from "./views/pages/analyticsPage/AnalyticsPage";
import UploadDocumentsPage from "./views/pages/UploadDocumentsPage/UploadDocumentsPage";
import UploadProgressDocumentsPage from "./views/pages/UploadProgressDocumentsPage/UploadProgressDocumentsPage";
import TermsAndConditionPage from "./views/pages/TermsAndConditionPage/TermsAndConditionPage";
import PrivacyPolicyPage from "./views/pages/PrivacyPolicyPage/PrivacyPolicyPage";
import LegalDocumentsPage from "./views/pages/legal/LegalDocumentsPage";
import DashboardProgress from "./views/pages/dashboardProgress/DashboardProgress";
import ProgressAssociatedCompaniesPage from "./views/pages/associatedCompanies/ProgressAssociatedCompaniesPage";
import AdvanceAnalyticsPage from "./views/pages/analyticsPage/AdvanceAnalyticsPage";
import AdvanceAnalyticsProgressPage from "./views/pages/analyticsPage/AdvanceAnalyticsProgressPage";
import KnowledgeBase from "./views/pages/KnowledgeBase";
import CertificateVerification from "./views/pages/certificate/CertificateVerification";

// Progress Assessment Components
import ProgressAssessmentHistory from "./views/pages/progress-assessment/History";
import ProgressAssessmentDocuments from "./views/pages/progress-assessment/Documents";
import ProgressAssessmentNew from "./views/pages/progress-assessment/New";
import ProgressAssessmentQuestions from "./views/pages/progress-assessment/Questions";
import ProgressAssessmentReports from "./views/pages/progress-assessment/Reports";

const App = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const user = getUser();
        if (user) {
            dispatch(setLoginDetails(user));
        }
    }, [dispatch]);

    return <div className="App">
        <Routes>
            {/* Public Routes */}
            <Route path="/*" element={<NotFoundPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/forgotPassword" element={<ForgotPassword />} />
            <Route path="/OTPverify" element={<OTPverify />} />
            <Route path="/resetPassword" element={<ResetPassword />} />
            <Route path="/terms&condition" element={<TermsAndConditionPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/legal-documents" element={<LegalDocumentsPage />} />
            <Route path="/certificate/verify/:verificationCode" element={<CertificateVerification />} />

            {/* Protected Routes */}
            <Route element={<PrivateRoute />}>
                {/* Main Assessment Routes */}
                <Route path="/" element={<History />} />
                <Route path="/:id" element={<HomePage />} />
                <Route path="/view/:id" element={<HomePage />} />
                <Route path="/progress/:id" element={<Progress />} />
                <Route path="/view/progress/:id" element={<Progress />} />
                
                {/* Progress Assessment Routes - Consolidated */}
                <Route path="/progress-assessment">
                    <Route path="new" element={<ProgressAssessmentNew />} />
                    <Route path="history" element={<ProgressAssessmentHistory />} />
                    <Route path="documents" element={<ProgressAssessmentDocuments />} />
                    <Route path="questions" element={<ProgressAssessmentQuestions />} />
                    <Route path="reports" element={<ProgressAssessmentReports />} />
                </Route>
                
                {/* Dashboard Routes */}
                <Route path="/user/dashboard/:SId" element={<Dashboard />} />
                <Route path="/user/progress/dashboard/:SId" element={<DashboardProgress />} />
                <Route path="/user/history" element={<History />} />
                <Route path="/pdf/:SId" element={<PdfReportPage3 />} />
                <Route path="/user/profile" element={<ProfilePage />} />
                
                {/* Associated Companies Routes */}
                <Route path="/associatedCompanies" element={<AssociatedCompaniesPage />} />
                <Route path="/progress/associatedCompanies" element={<ProgressAssociatedCompaniesPage />} />
                
                {/* Analytics Routes */}
                <Route path="/analytics" element={<AnalyticsPage />} />
                <Route path="/advanceAnalytics" element={<AdvanceAnalyticsPage />} />
                <Route path="/progressAdvanceAnalytics" element={<AdvanceAnalyticsProgressPage />} />
                
                {/* Document Upload Routes */}
                <Route path="/uploadDocuments/:id" element={<UploadDocumentsPage />} />
                <Route path="/uploadProgressDocuments/:id" element={<UploadProgressDocumentsPage />} />
                
                {/* Knowledge Base Route */}
                <Route path="/knowledge-base" element={<KnowledgeBase />} />
            </Route>
        </Routes>
    </div>
}

export default App;
